module.exports = __webpack_public_path__ + "static/media/Roboto-Medium.03cac90b.woff";